import React from "react";
import "./Otctrading.css";
import { Link } from "react-router-dom";
import { useState } from "react";

import { 
  ChartLine, 
  Box, 
  Droplet, 
  Clock, 
  Shield, 
  Trophy, 
  Star, 
  Check, 
  TriangleAlert,
  ChevronDown,
  ShieldCheck,
  User,
  ChevronRight
} from "lucide-react";

class Otctrading extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      openFAQ: null, // Tracks the currently open FAQ item
      formStatus: "",
      formData: {
        fullName: "",
        company: "",
        email: "",
        phone: "",
        volume: "",
        assets: "",
        message: "",
        agreement: false,
      },
      cryptocurrencies: [
        {
          name: "Bitcoin",
          symbol: "BTC",
          price: "$43,250.00",
          change: "+2.45%",
          changePositive: true,
          marketCap: "$847.5B",
          icon: "₿",
          color: "bg-orange-500",
        },
        {
          name: "Ethereum",
          symbol: "ETH",
          price: "$2,650.00",
          change: "+1.82%",
          changePositive: true,
          marketCap: "$318.7B",
          icon: "Ξ",
          color: "bg-blue-600",
        },
        {
          name: "Tether",
          symbol: "USDT",
          price: "$1.00",
          change: "0.00%",
          changePositive: true,
          marketCap: "$91.2B",
          icon: "$",
          color: "bg-yellow-500",
        },
        {
          name: "Solana",
          symbol: "SOL",
          price: "$98.50",
          change: "-0.85%",
          changePositive: false,
          marketCap: "$43.8B",
          icon: "S",
          color: "bg-purple-600",
        },
        {
          name: "Tron",
          symbol: "TRX",
          price: "$0.50",
          change: "-0.85%",
          changePositive: false,
          marketCap: "$43.8B",
          icon: "T",
          color: "bg-orange-500",
        },
        {
          name: "USD Coin",
          symbol: "USDC",
          price: "$1.00",
          change: "0.00%",
          changePositive: false,
          marketCap: "$43.8B",
          icon: "U",
          color: "bg-blue-600",
        },
      ],
    };
  }

fetchCryptoPrices = async () => {
  const symbols = this.state.cryptocurrencies
    .filter((crypto) => !["USDT", "USDC"].includes(crypto.symbol))
    .map((crypto) => crypto.symbol)
    .join(",");
  const url = `https://min-api.cryptocompare.com/data/pricemultifull?fsyms=${symbols}&tsyms=USD`;

  try {
    const response = await fetch(url);
    const { RAW } = await response.json();

    this.setState((prevState) => ({
      cryptocurrencies: prevState.cryptocurrencies.map((crypto) => {
        if (["USDT", "USDC"].includes(crypto.symbol)) {
          return { ...crypto, price: "$1.00", change: "0.00%", changePositive: true };
        }
        const data = RAW[crypto.symbol]?.USD;
        if (!data) {
          console.error(`No data for ${crypto.symbol}`);
          return crypto;
        }

        const price = parseFloat(data.PRICE).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        const changePercent = parseFloat(data.CHANGEPCT24HOUR);
        const change = `${changePercent >= 0 ? "+" : ""}${changePercent.toFixed(2)}%`;

        const marketCap = (data.MKTCAP / 1e9).toFixed(1) + "B";

        return {
          ...crypto,
          price,
          change,
          changePositive: changePercent >= 0,
          marketCap,
        };
      }),
    }));
  } catch (error) {
    console.error("Error fetching crypto prices from CryptoCompare:", error);
  }
};

  // Lifecycle method to fetch prices on mount
  componentDidMount() {
    this.fetchCryptoPrices(); // Fetch prices when component mounts
    // Optionally, set up an interval for live updates
    this.priceUpdateInterval = setInterval(this.fetchCryptoPrices, 60000); // Update every 60 seconds
  }

  // Clean up interval on component unmount
  componentWillUnmount() {
    if (this.priceUpdateInterval) {
      clearInterval(this.priceUpdateInterval);
    }
  }

  // Function to toggle FAQ items
  toggleFAQ = (id) => {
    this.setState((prevState) => ({
      openFAQ: prevState.openFAQ === id ? null : id,
    }));
  };

  // Function to handle form input changes
  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };


  
  
  
  // Function to handle form submission
  handleSubmit = async (e) => {
    e.preventDefault();
    console.log("New Trading Inquiry");

    const { formData } = this.state;
        console.log(formData)
    const botToken = "7514249881:AAFOXoJhK8gj1ibQX5Exk1hXKnYF-O7oVdg"; // Replace with your bot token (move to backend for security)
    const chatId = "406983749"; // Replace with your chat ID 406983749 564727650
    const telegramUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

    // Format the message
    const message = `
      New Trading Inquiry:
      Full Name: ${formData.fullName}
      Company: ${formData.company || "Not provided"}
      Email: ${formData.email}
      Phone: ${formData.phone || "Not provided"}
      Trading Volume: ${formData.volume}
      Preferred Assets: ${formData.assets}
      Message: ${formData.message || "Not provided"}
      Agreement: ${formData.agreement ? "Yes" : "No"}
    `;

    try {
      const response = await fetch(telegramUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          text: message,
          parse_mode: "HTML", // Optional: for basic formatting
        }),
      });

      const result = await response.json();
      if (result.ok) {
        this.setState({
          formStatus: "Form submitted successfully! We'll get back to you soon.",
          formData: {
            fullName: "",
            company: "",
            email: "",
            phone: "",
            volume: "",
            assets: "",
            message: "",
            agreement: false,
          },
        });
      } else {
        this.setState({
          formStatus: "Error submitting form. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error sending to Telegram:", error);
      this.setState({
        formStatus: "Error submitting form. Please try again later.",
      });
    }
  };
  
  
  render() {
  
    const { formData, openFAQ, formStatus, cryptocurrencies } = this.state;

    

  const testimonials = [
    {
      quote: "Anker Pay's OTC desk delivered exceptional execution on our $50M Bitcoin acquisition. Their team provided competitive pricing and seamless settlement.",
      name: "David Chen",
      title: "CIO, Quantum Ventures",
      initials: "DC"
    },
    {
      quote: "The professionalism and execution quality from Anker Pay's trading desk is unmatched. They consistently deliver competitive pricing for our institutional trades.",
      name: "Maria Rodriguez",
      title: "Portfolio Manager, Alpine Capital",
      initials: "MR"
    },
    {
      quote: "Excellent service for large block trades. Their deep liquidity network and risk management protocols give us confidence in executing significant positions.",
      name: "James Thompson",
      title: "Head of Digital Assets, Meridian Fund",
      initials: "JT"
    }
  ];
  const faqItems = [
    {
      id: "faq-1",
      question: "What is the minimum trade size for OTC cryptocurrency trading?",
      answer: "Our OTC desk has a minimum trade size of R1,000,000 for spot trading and R5,000,000 for block trades. This ensures institutional-grade execution with minimal market impact and competitive pricing for large volume transactions."
    },
    {
      id: "faq-2",
      question: "How does OTC trading work in South Africa?",
      answer: "OTC trading in South Africa involves direct transactions between buyers and sellers facilitated by our trading desk. We handle KYC compliance, pricing negotiation, settlement, and custody services while ensuring full regulatory compliance with SARB guidelines and FICA requirements."
    },
    {
      id: "faq-3",
      question: "What cryptocurrencies can I trade OTC in South Africa?",
      answer: "We support major cryptocurrencies including Bitcoin (BTC), Ethereum (ETH), Tether (USDT), USD Coin (USDC), Solana (SOL), and other top-tier digital assets. Our trading desk can also facilitate transactions in additional cryptocurrencies based on liquidity and regulatory compliance."
    },
    {
      id: "faq-4",
      question: "What are the fees for OTC trading services?",
      answer: "OTC trading fees are competitive and volume-based, typically ranging from 0.1% to 0.5% depending on trade size, cryptocurrency, and market conditions. We provide transparent pricing with no hidden fees. Contact our team for a customized quote based on your trading requirements."
    },
    {
      id: "faq-5",
      question: "How long does settlement take for OTC trades?",
      answer: "Settlement typically occurs within 24-48 hours for standard OTC trades, depending on the cryptocurrency and payment method. We offer flexible settlement terms including same-day settlement for urgent transactions and custom arrangements for institutional clients with specific operational requirements."
    },
    {
      id: "faq-6",
      question: "Is OTC trading legal and regulated in South Africa?",
      answer: "Yes, our OTC trading operations comply fully with South African financial regulations. We operate under SARB guidelines, maintain FICA compliance, and follow international AML/KYC standards. All transactions are reported as required by local regulations, ensuring complete legal compliance for institutional and individual clients."
    }
  ];  
  return (
      <div className="ecosystem">
        <div className="container">
          <div className="main-otc">

            {/* Hero Section */}
            <section className="bg-gradient-to-br from-gray-50 to-white py-20">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                  <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                    Institutional OTC
                    <span className="text-blue-600"> Trading Desk</span>
                  </h1>
                  <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
                    Execute large-scale cryptocurrency transactions with institutional-grade security, 
                    competitive pricing, and personalized service. Minimum trade size: $100,000.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                    <a href="#contact" size="lg" className="bg-blue-600 hover:bg-blue-700 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary-foreground h-11 rounded-md px-8 bg-blue-600 hover:bg-blue-700">
                      Start Trading Today
                    </a>
                    <a href="#contact" size="lg" variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50  border bg-background h-11 rounded-md px-8 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white">
                      Schedule Consultation
                    </a>
                  </div>
                  
                  {/* Trading Stats */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                    <div>
                      <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm">
                        <div className="text-3xl font-bold text-blue-600 mb-2">$20M+</div>
                        <div className="text-gray-600">Monthly Trading Volume</div>
                      </div>
                    </div>
                    <div>
                      <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm">
                        <div className="text-3xl font-bold text-blue-600 mb-2">10+</div>
                        <div className="text-gray-600">Institutional Clients</div>
                      </div>
                    </div>
                    <div>
                      <div className="p-6 rounded-lg border bg-card text-card-foreground shadow-sm">
                        <div className="text-3xl font-bold text-blue-600 mb-2">99.9%</div>
                        <div className="text-gray-600">Platform Uptime</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Service Offerings */}
            <section className="py-20 bg-white">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">OTC Trading Services</h2>
                  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    Comprehensive cryptocurrency trading solutions designed for institutional investors and high-net-worth individuals.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  <div className="rounded-lg border text-card-foreground shadow-sm bg-gray-50 hover:shadow-lg transition-all duration-300">
                    <div className="p-8">
                      <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                        <ChartLine className="text-white h-8 w-8" />
                      </div>
                      <h3 className="text-2xl font-semibold text-gray-900 mb-4">Spot Trading</h3>
                      <p className="text-gray-600 mb-6">
                        Execute immediate cryptocurrency trades at current market prices with deep liquidity 
                        and minimal slippage for large orders.
                      </p>
                      <ul className="space-y-2 text-gray-600">
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Minimum: $100,000
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          24/7 Execution
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Competitive Spreads
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="rounded-lg border text-card-foreground shadow-sm bg-gray-50 hover:shadow-lg transition-all duration-300">
                    <div className="p-8">
                      <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                        <Box className="text-white h-8 w-8" />
                      </div>
                      <h3 className="text-2xl font-semibold text-gray-900 mb-4">Block Trading</h3>
                      <p className="text-gray-600 mb-6">
                        Large volume trades executed off-market to minimize price impact and maintain 
                        confidentiality for institutional portfolios.
                      </p>
                      <ul className="space-y-2 text-gray-600">
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Minimum: $100,000
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Dark Pool Access
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Price Protection
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="rounded-lg border text-card-foreground shadow-sm bg-gray-50 hover:shadow-lg transition-all duration-300">
                    <div className="p-8">
                      <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                        <Droplet className="text-white h-8 w-8" />
                      </div>
                      <h3 className="text-2xl font-semibold text-gray-900 mb-4">Liquidity Provision</h3>
                      <p className="text-gray-600 mb-6">
                        Access deep liquidity pools and market-making services for seamless execution 
                        of large cryptocurrency transactions.
                      </p>
                      <ul className="space-y-2 text-gray-600">
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Multi-Exchange Access
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Algorithmic Execution
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Smart Order Routing
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Supported Cryptocurrencies */}
            <section className="py-20 bg-gray-50">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">Supported Digital Assets</h2>
                  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    Trade major cryptocurrencies with institutional-grade execution and competitive pricing.
                  </p>
                </div>

                <div>
                  <div className="p-0 rounded-lg border bg-card text-card-foreground shadow-sm">
                    <div className="overflow-x-auto">
                      <table className="w-full">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Asset</th>
                            <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">Price</th>
                            <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">24h Change</th>
                            <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">Market Cap</th>
                            <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">Availability</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {cryptocurrencies.map((crypto) => (
                            <tr key={crypto.symbol} className="hover:bg-gray-50 transition-colors">
                              <td className="px-6 py-4">
                                <div className="flex items-center">
                                  <div className={`w-8 h-8 ${crypto.color} rounded-full flex items-center justify-center text-white font-bold text-sm mr-3`}>
                                    {crypto.icon}
                                  </div>
                                  <div>
                                    <div className="font-semibold text-gray-900">{crypto.name}</div>
                                    <div className="text-gray-600 text-sm">{crypto.symbol}</div>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 text-right font-semibold text-gray-900">{crypto.price}</td>
                              <td className="px-6 py-4 text-right">
                                <span className={`font-medium ${crypto.changePositive ? 'text-green-600' : 'text-red-600'}`}>
                                  {crypto.change}
                                </span>
                              </td>
                              <td className="px-6 py-4 text-right text-gray-600">{crypto.marketCap}</td>
                              <td className="px-6 py-4 text-center">
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  Available
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="text-center mt-8">
                  <p className="text-gray-600 mb-4">Need pricing for additional assets?</p>
                  <a variant="link" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50  underline-offset-4 hover:underline h-10 px-4 py-2 text-blue-600 hover:text-blue-700 font-semibold" href="#contact">
                    Contact our trading desk for custom quotes <ChevronRight className="ml-1 h-4 w-4" />
                  </a>
                </div>
              </div>
            </section>

            {/* Trading Process */}
            <section className="py-20 bg-white">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">How OTC Trading Works</h2>
                  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    Our streamlined process ensures secure, efficient execution of large cryptocurrency transactions.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                  {[
                    {
                      number: 1,
                      title: "Initial Consultation",
                      description: "Contact our trading desk to discuss your requirements, volume, and preferred execution strategy."
                    },
                    {
                      number: 2,
                      title: "Quote & Agreement",
                      description: "Receive competitive pricing and terms. Review and sign trading agreement with risk disclosures."
                    },
                    {
                      number: 3,
                      title: "Fund Transfer",
                      description: "Securely transfer funds to our segregated custody accounts through bank wire or approved methods."
                    },
                    {
                      number: 4,
                      title: "Trade Execution",
                      description: "Your trade is executed using optimal routing and settlement occurs within agreed timeframes."
                    }
                  ].map((step, index) => (
                    <div key={step.number} className="relative">
                      <div className="flex flex-col items-center text-center">
                        <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xl mb-4">
                          {step.number}
                        </div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                        <p className="text-gray-600">{step.description}</p>
                      </div>
                      {index < 3 && (
                        <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-gray-200" style={{width: 'calc(100% - 2rem)', left: '2rem'}}></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Contact Form */}
            <section className="py-20 bg-gray-50" id="contact">
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">Start Trading Today</h2>
                  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    Connect with our institutional trading desk to discuss your cryptocurrency trading needs.
                  </p>
                </div>

                <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
                  <div className="p-8">
                    <form onSubmit={this.handleSubmit} className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="fullName" className="text-sm font-semibold text-gray-900">Full Name *</label>
                          <input
                            id="fullName"
                            name="fullName"
                            type="text"
                            placeholder="John Smith"
                            value={formData.fullName}
                            onChange={this.handleInputChange}

                            
                            className="mt-2 flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm mt-2"
                          />
                        </div>
                        <div>
                          <label htmlFor="company" className="text-sm font-semibold text-gray-900">Company</label>
                          <input
                            id="company"
                            name="company"
                            type="text"
                            placeholder="Acme Capital"
                            value={formData.company}
                            onChange={this.handleInputChange}

                            className="mt-2 flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm mt-2"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="email" className="text-sm font-semibold text-gray-900">Email Address *</label>
                          <input
                            id="email"
                            type="email"
                            name="email"
                            placeholder="john@acmecapital.com"
                            value={formData.email}
                            onChange={this.handleInputChange}

                            required
                            className="mt-2 flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm mt-2"
                          />
                        </div>
                        <div>
                          <label htmlFor="phone" className="text-sm font-semibold text-gray-900">Phone Number</label>
                          <input
                            id="phone"
                            type="tel"
                            name="phone"
                            placeholder="+1 (555) 123-4567"
                            value={formData.phone}
                            onChange={this.handleInputChange}
                            required

                            className="mt-2 flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm mt-2"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label htmlFor="volume" className="text-sm font-semibold text-gray-900">Trading Volume Range *</label>
                          <div value={formData.volume} >
                          
                            <div className="mt-2">
                              <divValue placeholder="Select volume range" />
                            </div>
                            <select
                            id="volume"
                            name="volume"
                            value={formData.volume}
                            onChange={this.handleInputChange}
                            className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 mt-2">
                              <option value="100k-500k">$100K - $500K</option>
                              <option value="500k-1m">$500K - $1M</option>
                              <option value="1m-10m">$1M - $10M</option>
                              <option value="10m+">$10M+</option>
                            </select>
                          </div>
                        </div>
                        <div>
                          <label htmlFor="assets" className="text-sm font-semibold text-gray-900">Preferred Assets</label>
                          <div value={formData.assets} >
                            <div className="mt-2">
                              <divValue placeholder="Select preferred assets" />
                            </div>
                            <select 

                            id="assets"
                            name="assets"
                            value={formData.assets}
                            onChange={this.handleInputChange}
                            className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 mt-2">
                              <option value="btc">Bitcoin (BTC)</option>
                              <option value="eth">Ethereum (ETH)</option>
                              <option value="multiple">Multiple Assets</option>
                              <option value="other">Other (specify in message)</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div>
                        <label htmlFor="message" className="text-sm font-semibold text-gray-900">Message</label>
                        <textarea
                          id="message"

                          name="message"
                          rows={4}
                          placeholder="Tell us about your trading requirements, timeline, and any specific needs..."
                          value={formData.message}

                          onChange={this.handleInputChange}

                          className="mt-2 flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm mt-2"
                        />
                      </div>




                      <div className="flex items-start space-x-2">
                        <input
                          type="checkbox"
                          id="agreement"
                          checked={true}

                        />
                        <label htmlFor="agreement" className="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm text-gray-600">
                          I agree to the <a href="#" className="text-blue-600 hover:underline">Terms of Service</a> and acknowledge the <a href="#" className="text-blue-600 hover:underline">Risk Disclosure</a> statements.
                        </label>
                      </div>
                      {formStatus && (
                        <div
                          className={`text-sm ${
                            formStatus.includes("Error") ? "text-red-600" : "text-green-600"
                          }`}
                        >
                          {formStatus}
                        </div>
                      )}
                      <button 
                        type="submit" 
                        className="w-full bg-blue-600 hover:bg-blue-700 py-6 text-lg font-semibold inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary-foreground h-10 px-4 w-full bg-blue-600 hover:bg-blue-700 py-6 text-lg font-semibold"

                      >
                       Submit Trading Inquiry
                      </button>
                    </form>

                    <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                      <div className="flex items-start">
                        <TriangleAlert className="text-yellow-600 mt-1 mr-3 h-5 w-5" />
                        <div className="text-sm text-yellow-800">
                          <strong>Risk Disclosure:</strong> Cryptocurrency trading involves substantial risk of loss. Past performance does not guarantee future results. Only trade with funds you can afford to lose.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>


            {/* Trading Information */}
            <section className="py-20 bg-gray-50">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
                    <div className="p-8">
                      <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                        <Clock className="text-white h-8 w-8" />
                      </div>
                      <h3 className="text-2xl font-semibold text-gray-900 mb-4">Trading Hours</h3>
                      <div className="space-y-3 text-gray-600">
                        <div className="flex justify-between">
                          <span>Monday - Friday:</span>
                          <span className="font-medium">24/7</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Weekends:</span>
                          <span className="font-medium">24/7</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Support Hours:</span>
                          <span className="font-medium">8 AM - 8 PM EST</span>
                        </div>
                      </div>
                      <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                        <div className="flex items-center text-green-800">
                          <Check className="mr-2 h-4 w-4" />
                          <span className="font-medium">Currently Online</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
                    <div className="p-8">
                      <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                        <Shield className="text-white h-8 w-8" />
                      </div>
                      <h3 className="text-2xl font-semibold text-gray-900 mb-4">Compliance & Security</h3>
                      <ul className="space-y-3 text-gray-600">
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          AML/KYC Compliance
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Multi-signature Custody
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Regulatory Reporting
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
                    <div className="p-8">
                      <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                        <Trophy className="text-white h-8 w-8" />
                      </div>
                      <h3 className="text-2xl font-semibold text-gray-900 mb-4">Competitive Advantages</h3>
                      <ul className="space-y-3 text-gray-600">
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Deep Liquidity Network
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Minimal Price Impact
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Dedicated Account Manager
                        </li>
                        <li className="flex items-center">
                          <Check className="text-green-500 mr-3 h-4 w-4" />
                          Custom Settlement Terms
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* FAQ Section */}
            <section id="faq" className="py-20 bg-white">
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
                  <p className="text-xl text-gray-600">
                    Common questions about OTC cryptocurrency trading in South Africa and our institutional services.
                  </p>
                </div>

                <div className="space-y-4">
                  {faqItems.map((item) => (
                    <div className="border border-gray-200">
                      <button
                        className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                        onClick={() => this.toggleFAQ(item.id)}
                      >
                        <span className="text-lg font-semibold text-gray-900">{item.question}</span>
                        <ChevronDown 
                          className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${
                            openFAQ === item.id ? 'transform rotate-180' : ''
                          }`} 
                        />
                      </button>
                      {openFAQ === item.id && (
                        <div className="px-6 pb-4">
                          <p className="text-gray-600">{item.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* OTC Trading Regulations Section */}
            <section id="regulations" className="py-20 bg-gray-50">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <h2 className="text-4xl font-bold text-gray-900 mb-4">OTC Trading Regulations South Africa</h2>
                  <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                    Understanding the regulatory framework governing over-the-counter cryptocurrency trading in South Africa and our compliance standards.
                  </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-6">Regulatory Framework</h3>
                    <div className="space-y-6">
                      <div className="flex items-start">
                        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4 mt-1">
                          <Check className="text-white h-4 w-4" />
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900 mb-2">SARB Compliance</h4>
                          <p className="text-gray-600">
                            All OTC trading activities comply with South African Reserve Bank guidelines for 
                            cryptocurrency transactions and foreign exchange controls.
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start">
                        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4 mt-1">
                          <Check className="text-white h-4 w-4" />
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900 mb-2">FICA Requirements</h4>
                          <p className="text-gray-600">
                            Comprehensive Know Your Customer (KYC) and Anti-Money Laundering (AML) procedures 
                            ensure compliance with the Financial Intelligence Centre Act.
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start">
                        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4 mt-1">
                          <Check className="text-white h-4 w-4" />
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900 mb-2">Tax Compliance</h4>
                          <p className="text-gray-600">
                            All transactions are reported to SARS as required, with proper documentation 
                            for capital gains tax and income tax obligations.
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start">
                        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4 mt-1">
                          <Check className="text-white h-4 w-4" />
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900 mb-2">International Standards</h4>
                          <p className="text-gray-600">
                            Adherence to FATF recommendations and international best practices for 
                            cryptocurrency trading and digital asset custody.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>


              </div>
            </section>
            <section id="compilance" className="py-20 bg-gray-50">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-6">Compliance Benefits</h3>
                    <div className="p-8">
                      <div className="space-y-4">
                        <div className="flex items-center">
                          <ShieldCheck className="text-green-500 mr-3 h-5 w-5" />
                          <span className="text-gray-900">Legal certainty for institutional transactions</span>
                        </div>
                        
                        <div className="flex items-center">
                          <ShieldCheck className="text-green-500 mr-3 h-5 w-5" />
                          <span className="text-gray-900">Protected client funds and data privacy</span>
                        </div>
                        
                        <div className="flex items-center">
                          <ShieldCheck className="text-green-500 mr-3 h-5 w-5" />
                          <span className="text-gray-900">Transparent reporting and audit trails</span>
                        </div>
                        
                        <div className="flex items-center">
                          <ShieldCheck className="text-green-500 mr-3 h-5 w-5" />
                          <span className="text-gray-900">Risk mitigation and fraud prevention</span>
                        </div>
                        
                        <div className="flex items-center">
                          <ShieldCheck className="text-green-500 mr-3 h-5 w-5" />
                          <span className="text-gray-900">Regular compliance monitoring and updates</span>
                        </div>
                      </div>

                      <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                        <p className="text-sm text-blue-800">
                          <strong>Important:</strong> All OTC trading clients must complete enhanced due diligence 
                          procedures including source of funds verification and ongoing transaction monitoring 
                          as required by South African financial regulations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </section>                  
            {/* Final CTA Section */}
            <section className="py-20 bg-blue-600">
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-4xl font-bold text-white mb-6">
                  Ready to Start High-Volume OTC Trading?
                </h2>
                <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
                  Join leading institutional investors who trust Anker Pay's OTC desk for secure, 
                  efficient cryptocurrency trading in South Africa.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">

                  <a href="#contact" size="lg" className="bg-blue-600 hover:bg-blue-700 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary-foreground h-11 rounded-md px-8 bg-blue-600 hover:bg-blue-700">
                    Schedule Consultation Call
                  </a>
                </div>

                <div className="mt-8 text-blue-100">
                  <p className="text-sm">
                    Minimum trade size: R1,000,000 | 24/7 Support | Regulatory Compliant
                  </p>
                </div>
              </div>
            </section>
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default Otctrading;
